import styled, { DefaultTheme } from 'styled-components'
import { ColorsEnum, ColorsToneEnum, FontWeightEnum, TypographyEnum } from 'types/cssTypes'

interface IProps {
  count?: number | string | JSX.Element
  color?: keyof DefaultTheme['colors']
  colorTone?: keyof typeof ColorsToneEnum
  backgroundColor?: keyof DefaultTheme['colors']
  backgroundColorTone?: keyof typeof ColorsToneEnum
  typography?: keyof typeof TypographyEnum
  fontWeight?: keyof typeof FontWeightEnum
}

export const CountLabel = ({
  count,
  color = ColorsEnum.secondary,
  colorTone = ColorsToneEnum.darker,
  backgroundColor = ColorsEnum.secondary,
  backgroundColorTone = ColorsToneEnum.darker,
  typography = TypographyEnum.h4,
  fontWeight = FontWeightEnum.bold,
}: IProps) => {
  return (
    <Span
      color={color}
      colorTone={colorTone}
      backgroundColor={backgroundColor}
      backgroundColorTone={backgroundColorTone}
      typography={typography}
      fontWeight={fontWeight}
    >
      {count}
    </Span>
  )
}

export const Span = styled.span<IProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xxxs};
  min-width: 2rem;
  color: ${({ theme, color, colorTone }) => theme.colors?.[color!][colorTone!]};
  background: ${({ theme, backgroundColor, backgroundColorTone }) =>
    theme.colors?.[backgroundColor!][backgroundColorTone!]};
  border-radius: ${({ theme }) => theme.borderRadius.normal};
  ${({ theme, typography, fontWeight }) => theme.typography[typography!][fontWeight!]}
`
